import { render } from "./reportarErro.vue?vue&type=template&id=d13deb38&scoped=true"
import script from "./reportarErro.vue?vue&type=script&lang=js"
export * from "./reportarErro.vue?vue&type=script&lang=js"

import "./reportarErro.vue?vue&type=style&index=0&id=d13deb38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d13deb38"]])

export default __exports__